import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import {
  COMMON_FORM_FIELD_CLASSES,
  FORM_FIELD_VARIANT_TYPES
} from '../utils/constants';
import Label from './Label';
import ErrorWrapper from './ErrorWrapper';

export const VARIANT_CLASSES = {
  [FORM_FIELD_VARIANT_TYPES.LARGE]: `${COMMON_FORM_FIELD_CLASSES} pv4 ph4 pv5-md fw5`,
  [FORM_FIELD_VARIANT_TYPES.REGULAR]: `${COMMON_FORM_FIELD_CLASSES} pv2 ph2`
};

export default function SimpleInput({
  autoComplete,
  displayErrors,
  errors,
  id,
  label,
  name,
  onChange,
  required,
  value,
  variant,
  ...inputProps
}) {
  return (
    <div className="Input">
      {
        label &&
          <Label
            htmlFor={ id }
            required={ required }
            text={ label }
          />
      }
      <ErrorWrapper
        isShown={ displayErrors }
        errors={ errors }
      >
        <input
          // autoComplete "off" does not prevent the user from autofilling but "nope" does
          autoComplete={ autoComplete === 'off' ? 'nope' : autoComplete }
          className={ classnames('Input__input', VARIANT_CLASSES[variant]) }
          data-test-id="form-input"
          id={ id }
          name={ name }
          onChange={ onChange }
          value={ value || '' }
          { ...inputProps }
        />
      </ErrorWrapper>
    </div>
  );
}

SimpleInput.propTypes = {
  autoComplete: PropTypes.string,
  displayErrors: PropTypes.bool,
  errors: PropTypes.arrayOf(PropTypes.node),
  id: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  type: PropTypes.string,
  value: PropTypes.string,
  /** One of: "regular" or "large". */
  variant: PropTypes.oneOf(Object.values(FORM_FIELD_VARIANT_TYPES))
};

SimpleInput.defaultProps = {
  // https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete#Values
  autoComplete: null,
  displayErrors: false,
  errors: [],
  id: null,
  label: null,
  required: false,
  type: 'text',
  value: null,
  variant: FORM_FIELD_VARIANT_TYPES.REGULAR
};
